import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CareerPathway } from '../../models/career-pathway/career-pathway.interface';
import { BehaviorSubject, Observable } from 'rxjs';
import { withCache } from '@ngneat/cashew';
import { constants } from '@edassist/common';

@Injectable({ providedIn: 'root' })
export class CareerPathwayService {
	careerPathwayData: Observable<Array<CareerPathway>>;

	private readonly relativeUrl = 'clients/';
	private readonly careerPathwayDataSubject: BehaviorSubject<
		Array<CareerPathway>
	>;

	constructor(private readonly http: HttpClient) {
		this.careerPathwayDataSubject = new BehaviorSubject<Array<CareerPathway>>(
			undefined
		);
		this.careerPathwayData = this.careerPathwayDataSubject.asObservable();
	}

	saveCareerPathway(
		clientId: number,
		careerPathway: CareerPathway
	): Observable<CareerPathway> {
		return this.http.post<CareerPathway>(
			`${this.relativeUrl}${clientId}/features/career-pathways`,
			careerPathway
		);
	}

	updateCareerPathway(
		clientId: number,
		updatedCareerPathway: CareerPathway
	): Observable<CareerPathway> {
		return this.http.put<CareerPathway>(
			`${this.relativeUrl}${clientId}/features/career-pathways/${updatedCareerPathway.id}`,
			updatedCareerPathway
		);
	}

	getCareerPathway(
		clientId: number,
		pathwayId: number
	): Observable<CareerPathway> {
		return this.http.get<CareerPathway>(
			`${this.relativeUrl}${clientId}/features/career-pathways/${pathwayId}`,
			{
				context: withCache({
					version: constants.LOCAL_STORAGE.API_CACHE.VERSION_V1,
					key: `getCareerPathway-${clientId}-${pathwayId}`
				})
			}
		);
	}

	getCareerPathways(clientId: number): void {
		this.http
			.get<
				Array<CareerPathway>
			>(`${this.relativeUrl}${clientId}/features/career-pathways`)
			.subscribe((careerPathways: Array<CareerPathway>) => {
				this.careerPathwayDataSubject.next(careerPathways);
			});
	}

	deleteCareerPathway(clientId: number, pathwayId: number): Observable<void> {
		return this.http.delete<void>(
			`${this.relativeUrl}${clientId}/features/career-pathways/${pathwayId}`
		);
	}
}
